module.exports = __webpack_public_path__ + "img/courtmatter_icon_active.3b8ba319.svg";